import { z } from 'zod';

export const setupAccountInputSchema = z.object({
  name: z.string().trim().min(1, { message: 'Name is required!' }),
  password: z
    .string()
    .trim()
    .min(1, { message: 'Password is required!' })
    .min(8, { message: 'Passowrd should be at least 8 characters long!' }),
});
